module.exports = __webpack_public_path__ + "img/icon-calendar.737fa659.svg";